import React from "react";

const ModalHeader = ({ onClick, icon, title, children }) => {
  return (
    <header className='py-4 px-3 font-semibold border-b border-black-200 text-black dark:border-black-800 dark:text-white' onClick={onClick}>
      {(icon || title) && (
        <span className='flex items-center gap-2'>
          {icon && icon}
          {title && title}
        </span>
      )}
      {children}
    </header>
  );
};

export default ModalHeader;
